<template>
  <main class="container-fluid">
    <div class="page-headline m-b-20 m-t-70 align-center">
      <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
      <h4 class="tagline page-headline__tagline about--description" v-html="pageInfo.content"></h4>
    </div>
    <div class="align-center">
      <a target="_blank" rel="noopener" v-bind:href="profileUrl" class="button button--primary">
        <span class="button--primary__text">{{ $t("global.companyProfile") }}</span>
      </a>
    </div>
    <div class="row section center-md align-center">
      <div class="col-md-4 col-sm-6 m-b-20-xs" v-for="about in aboutCompany" :key="about.id">
        <h1 class="headline m-b-30">{{ about.title }}</h1>
        <p>{{ about.content }}</p>
      </div>
    </div>
    <hr>
    <div class="row section the-story">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 m-b-20-xs">
        <h3 class="headline">{{ sectionOurStoryContent.title }}</h3>
        <span class="tagline" v-html="sectionOurStoryContent.content"></span>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <div class="story__step m-b-30" v-for="story in companyStory" :key="story.id">
          <h3>{{ story.title }}</h3>
          <p>{{ story.content }}</p>
        </div>
      </div>
    </div>
    <hr>
    <div class="row section">
      <h3 class="headline m-b-30">
        {{ sectionEnviromentContent.title }}
        <span
          class="tagline"
        >{{ sectionEnviromentContent.sub_title }}</span>
      </h3>
      <div class="row about-gallery">
        <img
          class="col-md-4 col-xs-12 image-box image--gray responsive-image"
          v-for="(image, index) in photoGallery"
          :src="image.image_url"
          :key="index"
        >
      </div>
    </div>
    <hr>
    <div class="section section-clients align-center">
      <div class="container">
        <div class="section__header">
          <h1 class="headline section__header__headline">{{ sectionClientsContent.title }}</h1>
          <span class="section__header__tagline">{{ sectionClientsContent.sub_title }}</span>
        </div>
        <div class="m-b-30">
          <img
            class="responsive-image"
            v-for="client in clients"
            :alt="client.name"
            :width="client.bio"
            :title="client.name"
            :src="client.logo_url"
            :key="client.id"
          >
        </div>

        <router-link
          class="button button--primary"
          :to="{ name: 'pricing', params: { lang: this.$i18n.locale }}"
        >
          <span class="button--primary__text">{{ $t("global.becomeAClient") }}</span>
        </router-link>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {},
      aboutCompany: [],
      companyStory: [],
      sectionOurStoryContent: {},
      sectionEnviromentContent: {},
      clients: [],
      sectionClientsContent: {},
      photoGallery: [],
      profileUrl:
        this.$i18n.locale === "en"
          ? "http://softcare.io/company_profile_en.pdf"
          : "http://softcare.io/company_profile_ar.pdf"
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [
        { itemprop: "name", content: this.pageInfo.meta_og_description },
        { itemprop: "description", content: this.pageInfo.meta_og_description },
        { name: "og:title", content: this.pageInfo.meta_og_title },
        { name: "og:description", content: this.pageInfo.meta_og_description },
        { name: "og:url", content: this.pageInfo.meta_url },
        { name: "og:site_name", content: this.pageInfo.meta_twitter_site },
        { name: "og:type", content: this.pageInfo.meta_og_type },
        { name: "og:image", content: this.pageInfo.meta_og_image_url },

        { name: "twitter:card", content: this.pageInfo.meta_twitter_card },
        { name: "twitter:site", content: this.pageInfo.meta_twitter_site },
        { name: "twitter:title", content: this.pageInfo.meta_twitter_title },
        {
          name: "twitter:description",
          content: this.pageInfo.meta_twitter_description
        },
        {
          name: "twitter:creator",
          content: this.pageInfo.meta_twitter_creator
        },
        { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
      ]
    };
  },
  created() {
    this.getAll();
    this.getPageInfo();
  },
  methods: {
    getPageInfo() {
      this.$http
        .get(this.$parent.$parent.apiURL + "/Pages?id=3")
        .then(function(response) {
          this.pageInfo = response.body;
          this.pageTitle = this.pageInfo.title;
        });
    },
    getAll() {
      this.$http
        .get(this.$parent.$parent.apiURL + "/Photogalleries?id=2")
        .then(function(response) {
          this.photoGallery = response.body.photos;
        });

      this.$http
        .get(this.$parent.$parent.apiURL + "/clients")
        .then(function(response) {
          this.clients = response.body;
        });

      this.$http
        .get(
          this.$parent.$parent.apiURL +
            "/textblocks?filter[name]=homepage-section-clients"
        )
        .then(function(response) {
          this.sectionClientsContent = response.body;
        });

      this.$http
        .get(
          this.$parent.$parent.apiURL +
            "/textblocks/text-blocks-widgets?filter[name]=page-about-us"
        )
        .then(function(response) {
          this.aboutCompany = response.body.widget_blocks;
        });

      this.$http
        .get(
          this.$parent.$parent.apiURL +
            "/textblocks/text-blocks-widgets?filter[name]=page-about-us-story"
        )
        .then(function(response) {
          this.companyStory = response.body.widget_blocks;
        });

      this.$http
        .get(
          this.$parent.$parent.apiURL +
            "/textblocks?filter[name]=about-us-section-story"
        )
        .then(function(response) {
          this.sectionOurStoryContent = response.body;
        });

      this.$http
        .get(
          this.$parent.$parent.apiURL +
            "/textblocks?filter[name]=about-us-section-enviroment"
        )
        .then(function(response) {
          this.sectionEnviromentContent = response.body;
        });
    }
  }
};
</script>

<style scoped>
.gallery-wrapper {
  flex: 1 0 33.333%;
  position: relative;
  height: 0;
  padding-bottom: 33.333%;
}

.gallery-wrapper img {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all 250ms ease-out;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue